var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{staticClass:"hiq-calendar__loader hiq-loader"},[_c('span',{staticClass:"show-for-sr",attrs:{"aria-live":"polite"}},[_vm._v(_vm._s(_vm.translations.loading))]),_c('div'),_c('div'),_c('div'),_c('div')]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }